var map = {
	"./artificial.png": "HBmr",
	"./bad.png": "qWqo",
	"./business.png": "bPnr",
	"./camera.png": "3OAi",
	"./cancel-on.png": "cXTr",
	"./cancel.png": "ugFW",
	"./close.png": "hSZV",
	"./closeVideo.png": "/3z+",
	"./copy.png": "UC34",
	"./customer.png": "jDit",
	"./customer_new.png": "qzzu",
	"./del.png": "GhMK",
	"./emoji.png": "RR7L",
	"./emoji/2_025f15f9.png": "PGJS",
	"./emoji/2_045f15f9.png": "6Rcw",
	"./emoji/2_055f15f9.png": "42gX",
	"./emoji/2_065f15f9.png": "l6/4",
	"./emoji/2_095f15f9.png": "dVYf",
	"./emoji/2_115f15f9.png": "aOpB",
	"./emoji/2_125f15f9.png": "v5cj",
	"./emoji/2_155f15f9.png": "j1hk",
	"./emoji/2_165f15f9.png": "i2o1",
	"./emoji/Addoil5f15f9.png": "cu4Z",
	"./emoji/Awesome5f15f9.png": "lCv0",
	"./emoji/Boring5f15f9.png": "mcPC",
	"./emoji/Broken5f15f9.png": "t/k1",
	"./emoji/Cold5f15f9.png": "YD63",
	"./emoji/Fireworks.png": "KqgG",
	"./emoji/Hurt5f15f9.png": "ihwY",
	"./emoji/KeepFighting5f15f9.png": "pihf",
	"./emoji/LetMeSee5f15f9.png": "FdZx",
	"./emoji/NoProb5f15f9.png": "8vGf",
	"./emoji/Shocked5f15f9.png": "4m2v",
	"./emoji/Sigh5f15f9.png": "+YDI",
	"./emoji/Slap5f15f9.png": "7ue4",
	"./emoji/Social5f15f9.png": "8Ed6",
	"./emoji/Sweat5f15f9.png": "8F5A",
	"./emoji/Watermelon5f15f9.png": "KYzw",
	"./emoji/Wow5f15f9.png": "Ue0T",
	"./emoji/Yellowdog5f15f9.png": "HbUk",
	"./emoji/smiley_05f15f9.png": "SvqV",
	"./emoji/smiley_105f15f9.png": "Xh4Z",
	"./emoji/smiley_115f15f9.png": "w6cd",
	"./emoji/smiley_125f15f9.png": "VJvY",
	"./emoji/smiley_135f15f9.png": "1fAE",
	"./emoji/smiley_145f15f9.png": "Islr",
	"./emoji/smiley_155f15f9.png": "H5KL",
	"./emoji/smiley_15f15f9.png": "GpPN",
	"./emoji/smiley_175f15f9.png": "1YFJ",
	"./emoji/smiley_185f15f9.png": "qmDU",
	"./emoji/smiley_195f15f9.png": "Gv5s",
	"./emoji/smiley_205f15f9.png": "5XhF",
	"./emoji/smiley_215f15f9.png": "RuKO",
	"./emoji/smiley_225f15f9.png": "5Gwo",
	"./emoji/smiley_235f15f9.png": "1Lus",
	"./emoji/smiley_255f15f9.png": "PvR8",
	"./emoji/smiley_25f15f9.png": "RdY9",
	"./emoji/smiley_265f15f9.png": "IW2y",
	"./emoji/smiley_275f15f9.png": "OgB1",
	"./emoji/smiley_285f15f9.png": "/bDo",
	"./emoji/smiley_295f15f9.png": "6BFY",
	"./emoji/smiley_305f15f9.png": "yI1H",
	"./emoji/smiley_315f15f9.png": "ka73",
	"./emoji/smiley_325f15f9.png": "uaMD",
	"./emoji/smiley_335f15f9.png": "QFoi",
	"./emoji/smiley_345f15f9.png": "bwU3",
	"./emoji/smiley_35f15f9.png": "dbIb",
	"./emoji/smiley_365f15f9.png": "hoB3",
	"./emoji/smiley_375f15f9.png": "MAJG",
	"./emoji/smiley_385f15f9.png": "pY5q",
	"./emoji/smiley_395f15f9.png": "FBKu",
	"./emoji/smiley_405f15f9.png": "/+Me",
	"./emoji/smiley_415f15f9.png": "Tqb5",
	"./emoji/smiley_425f15f9.png": "tQ4o",
	"./emoji/smiley_445f15f9.png": "rDYM",
	"./emoji/smiley_455f15f9.png": "LvzO",
	"./emoji/smiley_45f15f9.png": "7N8g",
	"./emoji/smiley_465f15f9.png": "dgDV",
	"./emoji/smiley_475f15f9.png": "zl16",
	"./emoji/smiley_485f15f9.png": "jkOP",
	"./emoji/smiley_495f15f9.png": "lfg9",
	"./emoji/smiley_505f15f9.png": "KPFj",
	"./emoji/smiley_515f15f9.png": "3VKF",
	"./emoji/smiley_525f15f9.png": "4zaR",
	"./emoji/smiley_545f15f9.png": "rq6b",
	"./emoji/smiley_555f15f9.png": "TC83",
	"./emoji/smiley_55f15f9.png": "84p2",
	"./emoji/smiley_565f15f9.png": "w2+U",
	"./emoji/smiley_575f15f9.png": "g8tF",
	"./emoji/smiley_605f15f9.png": "s6JS",
	"./emoji/smiley_625f15f9.png": "CqT+",
	"./emoji/smiley_635f15f9.png": "CcrQ",
	"./emoji/smiley_645f15f9.png": "nRb1",
	"./emoji/smiley_655f15f9.png": "aKL5",
	"./emoji/smiley_65f15f9.png": "kE87",
	"./emoji/smiley_665f15f9.png": "VOIy",
	"./emoji/smiley_675f15f9.png": "qgHP",
	"./emoji/smiley_685f15f9.png": "knP7",
	"./emoji/smiley_705f15f9.png": "Ww8U",
	"./emoji/smiley_745f15f9.png": "ewpu",
	"./emoji/smiley_755f15f9.png": "1N04",
	"./emoji/smiley_75f15f9.png": "dT+6",
	"./emoji/smiley_765f15f9.png": "ZzoF",
	"./emoji/smiley_785f15f9.png": "F61c",
	"./emoji/smiley_795f15f9.png": "XPL4",
	"./emoji/smiley_805f15f9.png": "7nff",
	"./emoji/smiley_815f15f9.png": "qfR1",
	"./emoji/smiley_825f15f9.png": "3Lvr",
	"./emoji/smiley_835f15f9.png": "WJmF",
	"./emoji/smiley_845f15f9.png": "5lsu",
	"./emoji/smiley_855f15f9.png": "pL1d",
	"./emoji/smiley_85f15f9.png": "l8xl",
	"./emoji/smiley_895f15f9.png": "HSRh",
	"./emoji/smiley_925f15f9.png": "feFO",
	"./emoji/smiley_935f15f9.png": "YXWR",
	"./emoji/smiley_945f15f9.png": "2YQ0",
	"./emoji/smiley_955f15f9.png": "kKQd",
	"./emoji/smiley_95f15f9.png": "xpOF",
	"./emoji/u1F3815f15f9.png": "dQyq",
	"./emoji/u1F3895f15f9.png": "8sA7",
	"./emoji/u1F47B5f15f9.png": "Gn6Y",
	"./emoji/u1F4AA.05f15f9.png": "Tr9Z",
	"./emoji/u1F6025f15f9.png": "7LRM",
	"./emoji/u1F6045f15f9.png": "+B1F",
	"./emoji/u1F6125f15f9.png": "Mdrq",
	"./emoji/u1F6145f15f9.png": "pdeY",
	"./emoji/u1F61D5f15f9.png": "RIkO",
	"./emoji/u1F6315f15f9.png": "onIT",
	"./emoji/u1F6335f15f9.png": "sVNT",
	"./emoji/u1F6375f15f9.png": "Otd8",
	"./emoji/u1F64F.05f15f9.png": "su1F",
	"./emoji/爆竹.png": "PVz6",
	"./evaluate-close.png": "6pCQ",
	"./evaluate.png": "UJJb",
	"./fail.png": "zRYA",
	"./feedback.png": "jO7p",
	"./file.png": "6y+D",
	"./good.png": "ijLc",
	"./keyboard.png": "8E3L",
	"./microphone.png": "sDMy",
	"./more.png": "KLZa",
	"./next.png": "n/xg",
	"./notice.png": "WOeW",
	"./pay_icon.png": "ICSn",
	"./photo.png": "CHdE",
	"./picture.png": "LvS6",
	"./send.png": "uT0r",
	"./star-block.png": "4ujj",
	"./star.png": "fpvN",
	"./success.png": "Agxa",
	"./tel.png": "Ugko",
	"./voice-black.png": "sfwW",
	"./voice-white.png": "mZxn",
	"./voice.png": "fXaX",
	"./warning.png": "lk7M"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YfKw";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon ^\.\/.*\.png$
// module id = YfKw
// module chunks = 1